import { Spacer } from '@chakra-ui/react';
import DeploymentsTable from '../tables/DeploymentsTable';

export const EnvironmentDeployments: React.FC = () => (
	<>
		<Spacer />
		<DeploymentsTable />
	</>
);
